﻿import React, { useCallback } from 'react';
import ReactMarkdown, { Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface MarkdownViewerProps {
    content: string;
    components?: Partial<Components>;
}

const defaultComponents: Partial<Components> = {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    a: ({ href, children, node, ...props }) => {
        const isExternal =
            href && !href.startsWith('/') && !href.startsWith('#');
        return (
            <a
                href={href}
                target={isExternal ? '_blank' : undefined}
                rel={isExternal ? 'noopener noreferrer' : undefined}
                {...props}
            >
                {children}
            </a>
        );
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    table: ({ children, node, ...props }) => (
        <table className='table table-striped' {...props}>
            {children}
        </table>
    )
};

const MarkdownViewer: React.FC<MarkdownViewerProps> = ({
    content,
    components
}) => {
    const renderMarkdown = useCallback(
        (markdownContent: string) => (
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                    ...defaultComponents,
                    ...components // User-provided overrides take precedence
                }}
            >
                {markdownContent}
            </ReactMarkdown>
        ),
        [components]
    );

    return <>{renderMarkdown(content)}</>;
};

export default MarkdownViewer;
